import React from 'react';
import { Form } from 'antd';
import { isEmpty } from 'ramda';
import { useTableLocale } from '../../use';
import SelectionForm from '../SelectionForm';
import SearchTable from '../SearchTable';
import { asserts, generators, network } from '../../../utils';
import api from '../../../config/api';
import SelectionTableModel from './model';
import Context from '../../layout/Container/Context';

const { generatorPagination } = generators;

const WrapperStore = ({ ...props }) => {
  const store = SelectionTableModel();
  return <WrapperComponent store={store} {...props} />;
};

const WrapperComponent = Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const { queryParams, isSpecialOffer, isIndustryZone } = props;
    const { state, dispatch } = props.store;
    const { pagination } = state;
    const { pageSize } = pagination;
    const params = {
      ...queryParams,
      ...allValues,
      pageSize,
      pageIndex: 1,
    };
    if (isSpecialOffer) {
      try {
        network.get(api.biLog.addLog, {
          params: {
            dataUrl: '/cust/es/queryItemSpecial.do',
            eventType: '特价区',
            scene: '活动专区',
            url: window.location.href,
            eventType1: '选项搜索',
          },
          silence: true,
        });
      } catch {}
    }
    isSpecialOffer
      ? dispatch('querySpecialTable')(params)
      : isIndustryZone
      ? dispatch('queryIndustryTable')(params)
      : dispatch('queryTable')(params);
  },
})(({ form, queryParams, isSpecialOffer, isIndustryZone, store: { state, loading, dispatch } }) => {
  const allFieldsValue = form.getFieldsValue();
  const { pagination, dataSource, favorite, stockList } = state;
  const { current, pageSize } = pagination;
  const [locale, fetchingStatus] = useTableLocale();
  const { principal } = React.useContext(Context);
  const isLoginIn = asserts.isExist(principal);
  const fetching =
    loading['querySpecialTable'] || loading['queryTable'] || loading['queryIndustryTable'];

  const fetchTable = React.useCallback(
    (params) => {
      if (isSpecialOffer) {
        try {
          network.get(api.biLog.addLog, {
            params: {
              dataUrl: '/cust/es/queryItemSpecial.do',
              eventType: '特价区',
              scene: '活动专区',
              url: window.location.href,
            },
            silence: true,
          });
        } catch {}
      }
      const modifiedParams = generatorPagination({
        ...queryParams,
        current,
        pageSize,
        ...params,
      });
      isSpecialOffer
        ? dispatch('querySpecialTable')(modifiedParams)
        : isIndustryZone
        ? dispatch('queryIndustryTable')(modifiedParams)
        : dispatch('queryTable')(modifiedParams);
    },
    [current, pageSize, queryParams], //eslint-disable-line
  );

  React.useEffect(() => {
    let isDidMount = true;
    if (isDidMount) {
      dispatch('updateState')({ dataSource: [] });
      if (!isEmpty(queryParams)) {
        fetchTable({ current: 1 });
      }
      dispatch('queryFavorite')();
      if (isLoginIn) dispatch('queryStockList')(); // 默认拉取拆分标识
    }
    return () => {
      isDidMount = false;
    };
  }, [queryParams]); //eslint-disable-line

  React.useEffect(() => {
    fetchingStatus(fetching);
  }, [fetching]); //eslint-disable-line

  const handleTableChange = (_pagination, filters, sorter) => {
    let { current, pageSize } = _pagination;
    if (pageSize !== pagination.pageSize) {
      current = 1;
    }
    dispatch('updateState')({ pagination: { ...pagination, current, pageSize } });
    fetchTable({ ...allFieldsValue, current, pageSize });
  };

  // 收藏
  const handleCollect = (record, val, isNew) => {
    const { itm, imitm, itemId, mmcu, ibmcu, moq, moqnum } = record;
    const params = {
      imitm: isSpecialOffer ? itm : imitm,
      itemId,
      ibmcu: isSpecialOffer ? mmcu : ibmcu,
      moqnum: isSpecialOffer ? moq : moqnum,
      uitemCode: val,
      uitemStatus: 0,
    };
    dispatch('collect')({
      collectParams: params,
      isSpecialOffer,
      tableQueryParams: generatorPagination({
        ...queryParams,
        ...allFieldsValue,
        current,
        pageSize,
      }),
      isNew,
    });
  };
  //自定义
  const handleCustom = (record, val, oldUitemCode = '') => {
    const { itm, imitm, itemId, mmcu, ibmcu, moq, moqnum } = record;

    const params = {
      imitm: isSpecialOffer ? itm : imitm,
      itemId,
      ibmcu: isSpecialOffer ? mmcu : ibmcu,
      moqnum: isSpecialOffer ? moq : moqnum,
      uitemCode: val,
      oldUitemCode: oldUitemCode || '',
    };
    dispatch('custom')({
      customParams: params,
      isSpecialOffer,
      tableQueryParams: generatorPagination({
        ...queryParams,
        ...allFieldsValue,
        current,
        pageSize,
      }),
    });
  };

  const handleStock = (isNew) => {
    if (isNew) dispatch('queryStockList')();
  };

  return (
    <>
      <SelectionForm
        values={queryParams}
        isSpecialOffer={isSpecialOffer}
        form={form}
        isIndustryZone={isIndustryZone}
      />
      <SearchTable
        data={dataSource}
        loading={
          loading['queryTable'] || loading['querySpecialTable'] || loading['queryIndustryTable']
        }
        pagination={pagination}
        favorite={favorite}
        stockList={stockList}
        isSpecialOffer={isSpecialOffer}
        isIndustryZone={isIndustryZone}
        locale={locale}
        handleCollect={handleCollect}
        handleCustom={handleCustom}
        handleStock={handleStock}
        onTableChange={handleTableChange}
      />
    </>
  );
});

export default WrapperStore;
